"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _get = _interopRequireDefault(require("transmute/get"));

var Identifiable = _interopRequireWildcard(require("../protocol/Identifiable"));

var _immutable = require("immutable");

var OwnerRecord = (0, _immutable.Record)({
  createdAt: 0,
  email: undefined,
  firstName: undefined,
  lastName: undefined,
  ownerId: undefined,
  portalId: undefined,
  quota: 0,
  remoteList: (0, _immutable.List)(),
  type: undefined,
  updatedAt: 0,
  signature: undefined,
  activeUserId: undefined,
  activeSalesforceId: undefined,
  // Extras
  active: false
}, 'OwnerRecord');
Identifiable.getId.implement(OwnerRecord, (0, _get.default)('ownerId'));

var getActive = function getActive(owner) {
  return Boolean(owner.activeSalesforceId || owner.activeUserId);
};

OwnerRecord.fromJS = function (json) {
  var active = getActive(json);
  return OwnerRecord((0, _extends2.default)({}, json, {
    active: active,
    remoteList: json.remoteList ? (0, _immutable.fromJS)(json.remoteList) : (0, _immutable.List)()
  }));
};

var _default = OwnerRecord;
exports.default = _default;
module.exports = exports.default;